import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const CHAT_CALLABLE_TIMEOUT_MS = 150_000;

export type ChatWithRealEstateResponse = {
  userMessageId: string;
  assistantMessageId: string;
  reply: string;
};

export function chatWithRealEstateErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Enter a shorter message and try again.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to chat about this property.';
    }
    if (code === 'functions/not-found') {
      return 'This property could not be found.';
    }
    if (code === 'functions/unavailable') {
      return 'Chat is temporarily unavailable. Try again in a moment.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'The reply timed out. Try again in a moment.';
    }
  }
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  return err instanceof Error ? err.message : 'Could not send the message.';
}

export async function chatWithRealEstate(
  propertyId: string,
  message: string,
  threadId: string
): Promise<ChatWithRealEstateResponse> {
  const fn = httpsCallable<
    { propertyId: string; message: string; threadId: string },
    ChatWithRealEstateResponse
  >(functions, 'chatWithRealEstate', { timeout: CHAT_CALLABLE_TIMEOUT_MS });
  return (
    await fn({
      propertyId: propertyId.trim(),
      message: message.trim(),
      threadId: threadId.trim(),
    })
  ).data;
}
